import { createFileRoute } from "@tanstack/react-router";
import { AdminPage } from "@/components/admin/AdminSidebar";
import { IdentidadesPanel } from "@/components/admin/plataforma/IdentidadesPanel";
import { StaffOnly } from "@/components/admin/plataforma/StaffOnly";

export const Route = createFileRoute("/admin/plataforma/identidades")({
  head: () => ({
    meta: [
      { title: "Identidades — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <AdminPage
      title="Identidades"
      description="Personas y empresas unificadas entre carteras, con su cola de conflictos."
    >
      <StaffOnly>
        <IdentidadesPanel />
      </StaffOnly>
    </AdminPage>
  ),
});
